module.exports = __webpack_public_path__ + "static/media/eye-icon.5790b882.svg";